module.exports = __webpack_public_path__ + "img/273.f66c9bb0.jpg";